
import { Vue, Component } from 'vue-property-decorator';
import { Advert } from '@/service';
import { userAgent } from '@/assets/ts/util';

@Component({
    name: 'success',
})
export default class Success extends Vue {
    public userAgent: any = userAgent;

    private adList: any[] = [];

    // 广告是否隐藏（禁投名单命中车场或 -1 全部，见 store getter）
    // @author logic
    // @date 2026-10-09
    get advertHidden(): boolean {
        return this.$store.getters.advertHidden;
    }

    public closeInWechat() {
        WeixinJSBridge.call('closeWindow');
    }

    public closeInAlipay() {
        ap.popWindow();
    }

    public async getAdvert() {
        const app = window.SERVER_CONFIG.APP_ENV;
        let ids = '';

        switch (app.toLowerCase()) {
            case 'prod':
                ids = '17';
                break;
            case 'zo':
                ids = '';
                break;
            case 'test':
                // no break;
            default:
                ids = '17';
                break;
        }

        if (!ids) {
            return;
        }

        try {
            let { data } = await Advert.list(ids);

            data = data || [];
            this.adList = data.filter((v: any) => v.place_status === 1);
            if (this.adList.length) {
                this.adRecord(this.adList[0].id, this.adList[0].advert_id);
            }
        } catch (err) {
            console.warn(err);
        }
    }

    public handleAdClick() {
        const { url, advert_id, id } = this.adList[0];

        this.adRecord(id, advert_id, true);

        if (url && url.match(/^http/)) {
            window.location.href = url;
        }
    }

    public async adRecord(id: number, aid: number, isClick: boolean = false) {
        try {
            await Advert.record({
                place_id: id,
                advert_id: aid,
                is_click: isClick ? 1 : 0,
                origin: 2,
            });
        } catch (err) {
            console.warn(err);
        }
    }

    private created() {
        if (window.SERVER_CONFIG.APP_ENV === 'zo') {
            this.getAdvert();
            return;
        }
        setTimeout(() => {
            switch (userAgent()) {
                case 'Wechat':
                    wx.miniProgram.getEnv((res: any) => {
                        if (res.miniprogram) {
                            wx.miniProgram.redirectTo({
                                url: '/pages/pay/success/success',
                            });
                        } else {
                          //  window.location.href = 'https://ac.yunzongnet.com/api/ac/466639647028596736';
                          window.close();
                        }
                    });
                    break;
                case 'Alipay':
                    if (window.AlipayJSBridge) {
                        if (this.advertHidden) {
                            // 禁投车场不跳第三方广告，停留成功页（用户可点关闭按钮）
                            break;
                        }
                        AlipayJSBridge.call('pushWindow', {
                            url: 'https://ac.yunzongnet.com/api/ac/466639647028596736',
                            param: {
                                backBehavior: 'pop',
                                closeCurrentWindow: true,
                            },
                        });
                    }
                    break;
                case 'H5':
                    // no break
                default:
                  window.close();
                    // this.getAdvert()
                   // window.location.href = 'https://ac.yunzongnet.com/api/ac/466639647028596736';
                  break;
            }
        }, 200);
    }
}
